import { MessagesUI } from '../Components/messages/MessageUi.jsx';

const Messages = () => {
  return <div><MessagesUI/>

  </div>;
}

export {Messages}